export default "__VITE_ASSET__38676b4f__"